// Imports
import convertPlainQuotes from '../shareables/utils/formatting/convert-plain-quotes';


/** Converts all plain quotes in an element to smart quotes. Also returns converted plain text */
export default function convertElementPlainQuotes(element: Node) {
	// Do not convert preformatted or style content
	if (['CODE', 'PRE', 'SCRIPT', 'STYLE', 'NOSCRIPT'].includes(element.nodeName.toUpperCase())) {
		return '';
	}
	
	
	// Initialize
	let context = '';
	const textNodes = [];
	
	
	// Determine context
	for (const child of element.childNodes) {
		if (child.nodeType === Node.TEXT_NODE) {
			// Convert the text node's content
			textNodes.push({ node: child, length: context.length });
			
			
			// Concatenate content to the context
			context += child.textContent;
		} else {
			// Recurse on the child node and add its context
			context += convertElementPlainQuotes(child);
		}
	}
	
	
	// Convert quotes in the context string
	const convertedText = convertPlainQuotes(context);
	
	
	// Update node text content
	for (const textNode of textNodes) {
		textNode.node.textContent = convertedText.slice(
			textNode.length,
			textNode.length + (textNode.node.textContent?.length ?? 0)
		);
	}
	
	
	// Return converted text
	return convertedText;
}
